import {Injectable} from '@angular/core';

@Injectable()

export class VJSConfig {

  userAuth = {
    name: "user_webservice%7C1",
    password: "okmijn098"
  };

  resourceDetails = [
    {
        id: "report_one",
        type: 'report',
        uri: '/reports/detalle',
        params : {}

    },
    {
    id: "dashboard_one",
    type: "dashboard",
    uri: "/public/Samples/Dashboards/1._Supermart_Dashboard",
    params: {}
  }, {
      id: "dashboard_two",
      type: "dashboard",
      uri: "/public/Samples/Dashboards/2._Performance_Summary_Dashboard",
      params: {}
    }, {
      id: "dashboard_three",
      type: "dashboard",
      uri: "/public/Samples/Dashboards/3.1_Sales_Metrics",
      params: {}
    }];
    
};